import { render, staticRenderFns } from "./modalHelpEscritorio.vue?vue&type=template&id=3c5d2e91&scoped=true&"
import script from "./modalHelpEscritorio.vue?vue&type=script&lang=js&"
export * from "./modalHelpEscritorio.vue?vue&type=script&lang=js&"
import style0 from "./modalHelpEscritorio.vue?vue&type=style&index=0&id=3c5d2e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d2e91",
  null
  
)

export default component.exports